import { Component, OnInit, ElementRef, HostListener, ViewChild, TemplateRef, AfterViewChecked, ViewChildren, QueryList } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LiveAnnouncer } from '@angular/cdk/a11y';

import { ChatAIConnectService } from '../services/api-esme-architecture/chatai-connect.service';

import { GetUrlParameters } from '../utils';
import { encode } from 'base64-arraybuffer';

import { Subject, Observable, forkJoin, of, timer } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatAlertComponent } from '../mat-alert';

@Component({
    selector: 'app-dynamic-forms',
    templateUrl: './dynamic-forms.component.html',
    styleUrls: ['./dynamic-forms.component.css'],
    standalone: false
})
export class DynamicFormsComponent implements OnInit, AfterViewChecked {

  @ViewChild('headerDiv') headerDivEl: ElementRef;
  @ViewChild('casePopContent', { static: true }) modalContent: TemplateRef<any>;
  // @ViewChild('ContentElement') ce: ElementRef;
  // @ViewChild('ContentElementheader') ceh: ElementRef;

  myImgSrc =  '/assets/askupload.svg';
  messagesParentDivHeight: number = screen.height - 310;
  serviceLines: any = [];
  selectedServiceLine: any;
  focusedLine: any;
  formElements: any = [];
  requestInProgress = false;
  myImgSrcPaperPlane = '/assets/paperplane.png';
  paperPlaneImageSrc = '/assets/paperplane.png';
  myCloseChat = '/assets/cancelchat.svg';
  // Flag is used to show loading by default and for the case if Request is taking more than a specified time(2 Sec).
  showLoading = false;
  loadingMessage = 'Processing your request, please wait…';
  slinesrc = '';
  currentPage = 1;
  pageSize = 5;

  formCreateCaseContext: any = {
    name: '',
    email: '',
    phone: '',
    notes: '',
    attachments: [],
    serverAttachments: []
  };

  alerts = [];
  dialogform = false;
  focusFirstElement = false;
  hideCreateCaseFrom = true;
  hideOnReset = true;
  // showAttachments = false;
  searchText = '';
  treeSearchText = '';
  modalMessage = 'Your session is about to expire, please complete the form or click reset to start again';
  modalTitle = 'User inactivity';
  output: any;
  proceed: any;
  popUp = true;

  userActivity;
  userInactive: Subject<any> = new Subject();
  transactionId: number;
  isDropdownOpen: boolean = false; 
  activeItemId: string = '';
  @ViewChildren('dropdownItem') dropdownItems!: QueryList<ElementRef>;
  @HostListener('window:message', ['$event'])
  onMessage(e) {
    if (e.data.ariaToken) {
      this.chatAIConnect.setAriaToken(e.data.ariaToken);
      this.loadServiceLines();
    }
    if (e.data === 'reset') {
      this.reset();
    }
  }

  constructor(
    public dialog: MatDialog,
    public chatAIConnect: ChatAIConnectService,
    private modalService: NgbModal,
    private liveAnnouncer: LiveAnnouncer
  ) {
    this.setTimeout();
    this.userInactive.subscribe(() => {
      this.modalMessage = `Your session will expire at ${(new Date(new Date().getTime() + 5 * 60000)).toTimeString().split(' ')[0].substring(0, 5)} after a further 5 minutes of inactivity`;
      this.modalTitle = 'User inactivity';
      this.openLg();
    });
  }

  ngOnInit() {
    if (GetUrlParameters().local) {
      this.loadServiceLines();
    }
    this.focusFirstElement = true;
  }

  ngAfterViewChecked() {
    if (!this.focusFirstElement) {
      return;
    }
    try {
      const focusable = document.querySelectorAll('button, input, select, textarea, radio, [tabindex]:not([tabindex="-1"])');
      const firstFocusable: HTMLInputElement = focusable[0] as HTMLInputElement;
      firstFocusable.focus();
      this.focusFirstElement = false;
    } catch {
    }
  }

  setTimeout() {
    this.userActivity = setTimeout(() => {
      this.userInactive.next(undefined);
    }, 60000 * 5);
  }

  loadServiceLines() {
    this.toggleInProgress();
    this.toggleLoading();

    this.chatAIConnect.postEnquiry('').subscribe(
      (response: any) => {
        this.serviceLines = response.message.generic[0].buttons;
        for (let i = 0; i < this.serviceLines.length; i++) {
          const label = this.serviceLines[i].label;
          this.serviceLines[i].onhov = 'assets/icons/hover/' + label.charAt(0).toUpperCase() + label.slice(1) + '.svg';
          const noHoverImg = 'assets/icons/' + label.charAt(0).toUpperCase() + label.slice(1) + '.svg';
          this.serviceLines[i].nohov = noHoverImg;
          this.serviceLines[i].imgsrc = noHoverImg;
        }
        this.toggleInProgress();
        this.toggleLoading();
      }, (error) => {
        this.alerts.push({ text: `An Error occurred - ${error.errorDetails || error.message || JSON.stringify(error)}` });
        this.toggleInProgress();
        this.toggleLoading();
      });
    this.dialogform = true;
  }

  // message in progress toggller
  toggleInProgress(): void {
    this.requestInProgress = !this.requestInProgress;
  }

  toggleLoading(): void {
    this.showLoading = !this.showLoading;
  }

  dismissAlert(index) {
    this.alerts.splice(index, 1);
  }

  activateServiceLine(serviceLine): void {
    this.hideOnReset = false;
    clearTimeout(this.userActivity);
    this.setTimeout();

    this.selectedServiceLine = serviceLine;

    this.toggleInProgress();
    this.toggleLoading();

    this.chatAIConnect.postEnquiry(serviceLine.value).subscribe(
      (response: any) => {
        this.toggleInProgress();
        this.toggleLoading();
        this.focusFirstElement = true;
        this.formatGenericResponse(response.message.generic);
        this.transactionId = response.transactionId;
      }, (error) => {
        this.alerts.push({ text: `An Error occurred - ${error.errorDetails || error.message || JSON.stringify(error)}` });
        this.toggleInProgress();
        this.toggleLoading();
      });
  }

  selectWithEnterKey(event, control, option) {
    if (event.key === 'Enter') {
      option.selected = true;
      this.sendControlSelection(option);
      control.selected = true;
      control.value = option.value;
    }
  }

  sendControlSelection(control): void {

    clearTimeout(this.userActivity);
    this.setTimeout();

    if (!control.value) {
      delete control.selected;
      return;
    }

    this.toggleInProgress();
    this.toggleLoading();

    this.chatAIConnect.postEnquiry(control.value, null, this.formCreateCaseContext.serverAttachments).subscribe(
      (response: any) => {
        this.transactionId = response.transactionId;
        if (response.nluAttributes.caseDetails) {
          this.modalTitle = 'Case details';
          this.modalMessage = response.message.generic[0].text;
          window.parent.postMessage('caseCreated', '*');
          this.openLg(true);
        } else {
          this.formatGenericResponse(response.message.generic);
        }
        // this.showAttachments = response.nluAttributes.showAttachments;
        if (response.nluAttributes.showAttachments) {
          this.formElements[this.formElements.length - 1].showAttachments = true;
        }
        this.toggleInProgress();
        this.toggleLoading();
      }, (error) => {
        // keep the input enabled so user can amend entry
        delete control.selected;
        if (error.errorDetails.includes('Session is expired')) {
          this.reset();
        }
        this.alerts.push({ text: `An Error occurred - ${error.errorDetails || error.message || JSON.stringify(error)}` });
        this.toggleInProgress();
        this.toggleLoading();
      });
  }

  attachKeyDown(event){
    if (event.key !== 'Enter') {
      return;
    }
    const attachButton = document.getElementById('file-input') as HTMLInputElement;
    attachButton.click();
  }

  handleFileInput = (files: FileList) => {
    if (files.length < 1) {
      return false;
    }
    // number of files
    if (files.length + this.formCreateCaseContext.attachments.length > 5) {
      this.alerts.push({ text: `Attached photos limit reached. Total number of files is ${files.length + this.formCreateCaseContext.attachments.length} exceeds limit of 5` });
      return;
    } else if (files.length > 5) {
      this.alerts.push({ text: `Attached photos limit reached. Total number of files is ${files.length} exceeds limit of 5` });
      return;
    }

    const observables = [];

    for (let i = 0; i < files.length; i++) {
      const fileToUpload = files.item(i);
      if (fileToUpload.size > 10000000) {
        this.alerts.push({ text: `Photo too large. File ${fileToUpload.name} size exceeds limit of 10mb` });
        return;
      }

      if (files.item(i).type.indexOf('image') < 0) {
        this.alerts.push({ text: `Incorrect file type, only upload images, File type ${files.item(i).type} is not valid` });
        return;
      }
    }

    for (let i = 0; i < files.length; i++) {
      const fileToUpload = files.item(i);
      observables.push(this.getBase64EncodedFileData(fileToUpload).pipe(
        switchMap((stringData) => this.chatAIConnect
          .postEnquiry('', { name: fileToUpload.name, filedata: stringData })
          .pipe(catchError((err) => of(err)))
      )));
    }

    this.toggleInProgress();
    this.toggleLoading();

    forkJoin(observables)
      .subscribe((responses: any) => {
        this.toggleInProgress();
        this.toggleLoading();
        let uploadsSuccesfull = true;
        responses.forEach((response) => {
          if (response.errorDetails) {
            this.alerts.push({ text: `File upload error. ${response.errorDetails}` });
            uploadsSuccesfull = false;
          } else {
            this.formCreateCaseContext.serverAttachments = this.formCreateCaseContext.serverAttachments.concat(response.attachments);
          }
        });

        if (uploadsSuccesfull) {
          for (let i = 0; i < files.length; i++) {
            const fileToUpload = files.item(i);
            const fileObservables = [];
            fileObservables.push(this.getFileUrl(fileToUpload));

            forkJoin(fileObservables)
              .subscribe((fileResponses: any) => {
                fileResponses.forEach((response) => {
                  this.formCreateCaseContext.attachments.push(response);
                });
              });
          }
        }
      });
  }

  getFileUrl(file: File): Observable<any> {
    return new Observable(observer => {
      const reader = new FileReader();
      reader.onload = () => {
        const { result } = reader;
        const url = result as string; // <--- FileReader gives us the ArrayBuffer
        observer.next({
          url,
          name: file.name
        });
        observer.complete();
      };
      reader.onerror = () => {
        observer.error(reader.error);
      };
      reader.readAsDataURL(file);
    });
  }

  getBase64EncodedFileData(file: File): Observable<string> {
    return new Observable(observer => {
      const reader = new FileReader();

      reader.onload = () => {
        const { result } = reader;
        const data = result as ArrayBuffer; // <--- FileReader gives us the ArrayBuffer
        const base64Encoded = encode(data); // <--- convert ArrayBuffer to base64 string

        observer.next(base64Encoded);
        observer.complete();
      };

      reader.onerror = () => {
        observer.error(reader.error);
      };

      reader.readAsArrayBuffer(file);
    });
  }

  getListInitialText(list): string {
    let text: any = {};
    text = list.find((item) => {
      if (item.selected) {
        return true;
      }
    });
    return text ? text.label : 'Select...';
  }

  formatServiceLineText(text): string {
    if (text === 'cleaning') {
      text = 'Cleaning / Medical';
    }

    if (text === 'grounds') {
      text = 'Grounds / Security';
    }
    return (text.charAt(0).toUpperCase() + text.slice(1)).split(/(?=[A-Z])/).join(' ');
  }

  submitForm() {
    const control = this.formElements[this.formElements.length - 1].controls[0];
    control.selected = true;
    if (!control.value) {
      control.value = 'nothing to add';
    }
    this.sendControlSelection(control);
  }

  private formatGenericResponse(generic): void {
    const formElement = {
      labels: [],
      controls: []
    };
    const hideCreateCaseFrom = true;

    generic.forEach((item) => {
      if (item.type === 'text') {
        formElement.labels.push(item);
        this.liveAnnouncer.announce(item.text);
      } else {
        item.hideCreateCaseFrom = hideCreateCaseFrom;
        formElement.controls.push(item);
      }
    });
    this.formElements.push(formElement);
  }

  openLg(resetForm?: boolean): void {
    const modalRef = this.modalService.open(this.modalContent, { size: 'lg' });
    modalRef.result.then((result) => {
      if (resetForm) {
        this.reset();
      }
    }).catch((error) => {
      if (resetForm) {
        this.reset();
      }
    });
  }

  reset() {
    this.chatAIConnect.clearConversationContext();
    this.modalMessage = '';
    this.modalTitle = '';
    this.selectedServiceLine = undefined;
    this.formCreateCaseContext.attachments = [];
    this.alerts = [];
    this.hideCreateCaseFrom = true;
    // this.showAttachments = false;
    this.formElements = [];
    this.transactionId = undefined;
    this.hideOnReset = !this.hideOnReset;
    window.location.reload();
  }

  toggle(e: HTMLElement) {
    e.classList.toggle('hidden');
  }

  cardFocus(serviceLine) {
    this.focusedLine = serviceLine;
  }
  cardFocusOut() {
    this.focusedLine = undefined;
  }

  cardKeydown(event) {
    if (event.key === 'Enter' && this.focusedLine) {
      this.activateServiceLine(this.focusedLine);
    }
  }

  onSelectedtreeItemClick(option: any) {
    event.preventDefault();
    this.sendControlSelection(option);
  }

  createId(): string {
    return this.createGuid();
  }

  private createGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  confirmDialog() {
    const ref = this.dialog.open(
      MatAlertComponent,
      {
        width: '600px',
        height: '210px',
        data: {
          case: 'Default',
          message: 'Is it an emergency, critical issue or any risk to health and safety',
        },
        backdropClass: 'confirmDialogComponent',
        hasBackdrop: true,
      }
    );
    ref.afterClosed().subscribe(res => {
      this.output = res.clicked;
      if (this.output === 'Yes') {
        const ref2 = this.dialog.open(
          MatAlertComponent,
          {
            width: '600px',
            height: '210px',
            data: {
              case: 'Ok',
              message: 'Please call the service desk right away',
            },
            backdropClass: 'confirmDialogComponent',
            hasBackdrop: true,
          }
        );

        ref2.afterClosed().subscribe(res2 => {
          this.proceed = res2.clicked;
          if (this.proceed === 'Proceed')
          {
            this.dialogform = true;
          }
        });
      } else {
        this.dialogform = true;
      }
    });
}
toggleDropdown(): void {
  this.isDropdownOpen = !this.isDropdownOpen;

  if (this.isDropdownOpen) {
    // Delay setting focus to allow DOM update
    setTimeout(() => {
      const firstItem = this.dropdownItems?.first?.nativeElement;
      if (firstItem) {
        firstItem.focus();  // Ensures Safari VoiceOver reads the first option
      }
    }, 100);
  }
}
selectItem(listItem: any, index: number): void {
  this.isDropdownOpen = false;
  listItem.selected = true;
  this.activeItemId = `listItem-${index}`;
  this.sendControlSelection(listItem);
}

// Handle keyboard navigation for accessibility
onKeyDown(event: KeyboardEvent): void {
  if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
    event.preventDefault();
    this.isDropdownOpen = true;
    
    setTimeout(() => {
      const firstItem = this.dropdownItems?.first?.nativeElement;
      if (firstItem) {
        firstItem.focus();
      }
    }, 100);
  }
}

}
